import type { RouteRecordRaw } from 'vue-router';

export const routes: RouteRecordRaw[] = [
  {
    path: '/:slug/wins',
    name: 'wins',
    component: () => import('./pages/WinsPage.vue'),
  },
];
